import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function PedidosCreateTallas() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_COLABORADORES_CLIENTES = process.env.REACT_APP_URL_COLABORADORES_CLIENTES;
  const URL_COLABORADORES_TALLAS = process.env.REACT_APP_URL_COLABORADORES_TALLAS;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_COTIZACIONES = process.env.REACT_APP_URL_COTIZACIONES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_ARTICULOS_COTIZACION = process.env.REACT_APP_URL_ARTICULOS_COTIZACION;
  const URL_COMPRADORES = process.env.REACT_APP_URL_COMPRADORES;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_EXPLOSION_GLOBAL = process.env.REACT_APP_URL_EXPLOSION_GLOBAL;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;
  const URL_SOCIEDADES = process.env.REACT_APP_URL_SOCIEDADES;
  const URL_AREAS_CLIENTES = process.env.REACT_APP_URL_AREAS_CLIENTES;
  const URL_SUCURSALES = process.env.REACT_APP_URL_SUCURSALES;

  let hoy = new Date()
  // let inicio = new Date()
  // inicio.setDate(inicio.getDate()-60);

  let endDate   = moment(hoy).format("YYYY-MM-DD");
  // let startDate   = moment(inicio).format("YYYY-MM-DD");

  const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];

  const [articulos, setArticulos] = useState([]);
  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [cotizaciones, setCotizaciones] = useState([]);
  const [cotizacionesCliente, setCotizacionesCliente] = useState([]);
  const [selectedCotizacion, setSelectedCotizacion] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [pedidoCliente, setPedidoCliente] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [comprador, setComprador] = useState("");
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [idArt, setIdArt] = useState("");
  const [idArtPdr, setIdArtPdr] = useState("");
  const [codigoCliente, setCodigoCliente] = useState("NA");
  const [codigo, setCodigo] = useState("");
  const [precioEtiqueta, setPrecioEtiqueta] = useState(0);
  const [value, setValue] = useState("");
  const [descuento, setDescuento] = useState(0);
  const [precio, setPrecio] = useState();
  const [sociedades, setSociedades] = useState([]);
  const [selectedSociedad, setSelectedSociedad] = useState("");
  const [areasClientesOptions, setAreasClientesOptions] = useState([]);
  const [sucursalesClientes, setSucursalesClientes] = useState([]);
  // const [selectedSociedad, setSelectedSociedad] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [fecha, setFecha] = useState(endDate);
  const [fecha_cancelacion, setFechaCancelacion] = useState("");
  const [fecha_confirmacion, setFechaConfirmacion] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [total_piezas, setTotalPiezas] = useState(0);
  const [compradores, setCompradores] = useState([]);
  const [selectedComprador, setSelectedComprador] = useState("");
  const [pendFechaConf, setPendFechaConf] = useState("");

  const [colaboradoresClientes, setColaboradoresClientes] = useState([]);
const [colaboradoresTallas, setColaboradoresTallas] = useState([]);

  const [telas, setTelas] = useState([]);
  const [modalExplosiones, setModalExplosiones] = useState(false);
  const toggleExplosiones = () => setModalExplosiones(!modalExplosiones);
  const [inputFieldsTela, setInputFieldsTela] = useState([
    {
      id: uuidv4(),
      idTela: "",
      idColor: "",
      cantidad: 0,
      observaciones: "NA",
    },
  ]);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      areasClientes: "",
      sucursales: "",
      articulos: "",
      articulosNombre: "",
      colores: "",
      arrayColoresArticulo: [],
      tallas: "",
      arrayTallasArticulo: [],
      cantidad: 0,
      precio: 0,
      tela: "",
      descuento: 0,
      total: 0,
      tc: [],
      totalArt: 0,
      cantidadGlobal: 1,
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

useEffect(() => {
  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  Promise.all([
    axios.get(URL_ARTICULOS, { headers }),
    axios.get(URL_COLORES, { headers }),
    axios.get(URL_TALLAS, { headers }),
    axios.get(URL_CLIENTES, { headers }),
    axios.get(`${URL_COTIZACIONES}Abiertas`, { headers }),
    axios.get(URL_COLABORADORES, { headers }),
    axios.get(URL_COMPRADORES, { headers }),
    axios.get(URL_EMPRESAS, { headers }),
    axios.get(URL_TELAS, { headers }),
    axios.get(URL_SOCIEDADES, { headers }),
    axios.get(URL_AREAS_CLIENTES, { headers }),
  ])
    .then(
      ([
        resArticulos,
        resColores,
        resTallas,
        resClientes,
        resCotizaciones,
        resColaboradores,
        resCompradores,
        resEmpresas,
        resTelas,
        resSociedades,
        resAreasClientes,
      ]) => {
        setArticulos(resArticulos.data);
        setColores(resColores.data);
        setTallas(resTallas.data);
        setClientes(resClientes.data);
        setCotizaciones(resCotizaciones.data);
        setColaboradores(resColaboradores.data);
        setCompradores(resCompradores.data);
        setEmpresas(resEmpresas.data);
        setTelas(resTelas.data);
        setSociedades(resSociedades.data);
        setAreasClientesOptions(resAreasClientes.data);
      }
    )
    .catch((err) => {
      console.error("Error al cargar catálogos:", err);
    });
}, []);

useEffect(() => {
  if (!value?._id) {
    setCotizacionesCliente([]);
    setSelectedCotizacion(""); // limpia cotización si cambia cliente
    return;
  }

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  axios
    .get(`${URL_COTIZACIONES}Abiertas`, { headers })
    .then((res) => {
      const todas = res.data;
const filtradas = todas.filter((c) => {
  const cotCliente = c.clientes?.[0];
  const cotClienteId = typeof cotCliente === "string" ? cotCliente : cotCliente?._id;
  return String(cotClienteId) === String(value._id);
});


      setCotizacionesCliente(filtradas);
    })
    .catch((err) => {
      console.error("Error al filtrar cotizaciones del cliente:", err);
    });
}, [value]);

useEffect(() => {
  if (!selectedCotizacion) return;

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  axios
    .get(`${URL_ARTICULOS_COTIZACION}/cotizaciones/${selectedCotizacion}`, { headers })
    .then((resArt) => {
      cargarArticulosDesdeCotizacion(resArt.data);
    })
    .catch((err) =>
      console.error("Error al cargar artículos de cotización:", err)
    );
}, [selectedCotizacion]);

useEffect(() => {
  if (!value?._id) {
    setSucursalesClientes([]); // o el estado que uses para guardar las sucursales
    return;
  }

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  axios
    .get(`${URL_SUCURSALES}/clientes/${value._id}`, { headers })
    .then((res) => {
      setSucursalesClientes(res.data); // Actualiza tu estado de sucursales aquí
    })
    .catch((err) => {
      console.error("Error al cargar sucursales del cliente:", err);
    });
}, [value]);

useEffect(() => {
  ActualizaTotales();
}, [inputFields]);

useEffect(() => {
  if (!value?._id) {
    setColaboradoresClientes([]);
    return;
  }

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  axios
    .get(`${URL_COLABORADORES_CLIENTES}/cliente/${value._id}`, { headers })
    .then((res) => {
      setColaboradoresClientes(res.data);
    })
    .catch((err) => {
      console.error("Error al cargar colaboradoresClientes:", err);
    });
}, [value]);

useEffect(() => {
  if (!value?._id) {
    setColaboradoresTallas([]);
    return;
  }

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  axios
    .get(`${URL_COLABORADORES_TALLAS}`, { headers })
    .then((res) => {
      setColaboradoresTallas(res.data);
    })
    .catch((err) => {
      console.error("Error al cargar colaboradoresTallas:", err);
    });
}, [value]);


  // (2026-10) Enter en un campo ya no guarda el pedido a medio capturar; solo
  // se guarda con el botón. En observaciones (textarea) Enter sigue siendo
  // salto de línea y sobre un botón sigue funcionando.
  const evitaGuardarConEnter = (e) => {
    if (e.key !== "Enter") return;
    const t = e.target;
    if (t.tagName === "TEXTAREA" || t.tagName === "BUTTON") return;
    e.preventDefault();
  };

  const savePedido = async (event) => {
  event.preventDefault();
  setValidaBoton(false);
  toggleProgreso();

  let inicio = new Date(fecha_cancelacion);
  let bla = inicio.setDate(inicio.getDate() - 60);
  let fechaStatus = moment(bla).format("YYYY-MM-DD");

  let totalPedido = inputFields.length + inputFieldsTela.length;

  try {
    const { data: pedidoCreado } = await axios.post(
      URL_PEDIDOS,
      {
        fecha,
        fechaCreacion: endDate,
        resurtido: "Si",
        empresas: "64554028db17c2f7f0a771c2",
        clientes: value._id,
        colaboradores: selectedColaborador,
        fecha_cancelacion,
        fecha_confirmacion: fecha_cancelacion,
        total_general,
        total_piezas,
        compradores: "6776c839c763d45da2f0f5b7",
        observaciones,
        pedidoCliente,
        surtido: 0,
        pendiente_surtir: total_piezas,
        confirmacionPedido: "No",
        status: "Abierto",
        fechaEstCodigos: fechaStatus,
        fechaEstFicha: fechaStatus,
        fechaEstAuditoria: fechaStatus,
        fechaEstMuestraFit: fechaStatus,
        fechaEstMuestraConfirmacion: fechaStatus,
        fechaEstEtiquetas: fechaStatus,
        fechaRealCodigos: fechaStatus,
        fechaRealFicha: fechaStatus,
        fechaRealAuditoria: fechaStatus,
        fechaRealMuestraFit: fechaStatus,
        fechaRealMuestraConfirmacion: fechaStatus,
        fechaRealEtiquetas: fechaStatus,
        autorizacionFitFecha: fechaStatus,
        autorizacionCostosFecha: fechaStatus,
        autorizacionDisenoFecha: fechaStatus,
        autorizacionCalidadFecha: fechaStatus,
        autorizacionPloterFecha: fechaStatus,
        autorizacionPloterDisenoFecha: fechaStatus,
        autorizacionSurtirFecha: fechaStatus,
        autorizacionFitColaborador: "613a9434225bce3df050c220",
        autorizacionCostosColaborador: "613a9434225bce3df050c220",
        autorizacionDisenoColaborador: "613a9434225bce3df050c220",
        autorizacionCalidadColaborador: "613a9434225bce3df050c220",
        autorizacionPloterColaborador: "613a9434225bce3df050c220",
        autorizacionPloterDisenoColaborador: "613a9434225bce3df050c220",
        autorizacionSurtirColaborador: "613a9434225bce3df050c220",
        descuento,
        pendFechaConf: "Si",
        sociedades: "6775c905d688145c579d8393",
        cotizaciones: selectedCotizacion || null, // 👉 incluye cotización si existe
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    const idPedido = pedidoCreado._id;

    // 👉 Actualizar cotización
    if (selectedCotizacion) {
      axios.patch(
        `${URL_COTIZACIONES}/${selectedCotizacion}`,
        {
          status: "Pedido",
          pedidos: idPedido,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      ).catch((err) =>
        console.error("Error al actualizar cotización:", err)
      );
    }

    // Guardar artículos del pedido
    for (const a of inputFields) {
      if (a.articulos !== "" && a.totalArt !== 0) {
        for (const b of a.tc) {
      await axios.post(
  URL_ARTICULOS_PEDIDO,
  {
    pedidos: idPedido,
    articulos: a.articulos?._id,
    colores: b.colores?._id,
    tallas: b.tallas?._id,
    cantidad: parseFloat(b.cantidad),
    pendienteCortar: parseFloat(b.cantidad),
    cortado: 0,
    surtido: 0,
    pendiente_surtir: parseFloat(b.cantidad),
    cantidad_procesos: parseFloat(b.cantidad),
    precio: parseFloat(a.precio) || 0,
    tela: a.tela,
    descuento: parseFloat(a.descuento) || 0,
    total: parseFloat(a.total) || 0,
    codigoBarras: 0,
    precioEtiqueta: precioEtiqueta || 0,
    resurtido: "Si",
    codigoCliente,
    sociedades: "6775c905d688145c579d8393",
    areasClientes: a.areasClientes,
    sucursales: a.sucursales,
  },
  {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  }
);

        }
      }
      totalPedido--;
    }

    // Puedes habilitar este bloque para guardar inputFieldsTela si los usas
    // for (const a of inputFieldsTela) {
    //   if (a.idTela !== "" && a.idColor !== "" && a.cantidad > 0) {
    //     await axios.post(URL_EXPLOSION_GLOBAL, {
    //       articulos: idArt,
    //       pedidos: idPedido,
    //       telas: a.idTela,
    //       colores: a.idColor,
    //       cantidad: a.cantidad,
    //       tipo: "Tela",
    //       observaciones: a.observaciones,
    //     }, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } });
    //     totalPedido--;
    //   }
    // }

    // Guardar log
    await axios.post(
      URL_LOGS,
      {
        tipo: "Crear Pedido",
        detalle: `${value._id} ${total_general}`,
        user: user.id,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    Swal.fire("Good job!", `Creado con éxito, Pedido ${pedidoCreado.idPedido}`, `success`);
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  } catch (error) {
    console.error("Error al crear pedido:", error);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
      footer: `${error.response?.data || "Error desconocido"}`,
    });
    setValidaBoton(true);
  }
};

 const handleAddFields = () => {
  setInputFields((prevFields) => [
    ...prevFields,
    {
      id: uuidv4(),
      areasClientes: "",
      sucursales: "",
      articulos: "",
      articulosNombre: "",
      colores: "",
      arrayColoresArticulo: [],
      tallas: "",
      arrayTallasArticulo: [],
      cantidad: 0,
      precio: 0,
      tela: "NA",
      descuento: 0,
      total: 0,
      tc: [],
      totalArt: 0,
      cantidadGlobal: 1,
    },
  ]);
};

const handleRemoveFields = (id) => {
  setInputFields((prevFields) =>
    prevFields.length > 1
      ? prevFields.filter((field) => field.id !== id)
      : prevFields
  );
  ActualizaTotales()
};

async function BuscaArticulo(id, selectedArticulo) {
  const input = inputFields.find((i) => i.id === id);
  const clienteId = value?._id?.toString();
  const sucursalId = input?.sucursales?.toString();
  const areaId = input?.areasClientes?.toString();
  const cantidadGlobal = parseInt(input?.cantidadGlobal) || 1;

  const coloresArticulo = selectedArticulo.colores || [];
  const tallasArticulo = selectedArticulo.tallas || [];

  const selectedDepartamento =
    selectedArticulo.departamentos?.[0]?._id?.toString() || selectedArticulo.departamentos?.[0]?.toString();
  const selectedSubDepartamento =
    selectedArticulo.subDepartamentos?.[0]?._id?.toString() || selectedArticulo.subDepartamentos?.[0]?.toString();

  const colaboradoresFiltrados = colaboradoresClientes.filter((col) =>
    col.is_active === "Si" &&
    col.clientes?.map(obj => obj._id?.toString()).includes(clienteId) &&
    col.sucursales?.map(obj => obj._id?.toString()).includes(sucursalId) &&
    col.areasClientes?.map(obj => obj._id?.toString()).includes(areaId)
  );

  const nuevosTC = [];

  for (let color of coloresArticulo) {
    for (let talla of tallasArticulo) {
      nuevosTC.push({
        colores: color,
        tallas: talla,
        tallaNombre: talla.name,
        cantidad: 0,
      });
    }
  }

  for (let col of colaboradoresFiltrados) {
    const registroTallas = colaboradoresTallas.find((ct) =>
      ct.is_active === "Si" &&
      ct.colaboradoresClientes?.map(obj => obj._id?.toString()).includes(col._id.toString()) &&
      ct.clientes?.map(obj => obj._id?.toString()).includes(clienteId) &&
      ct.departamentos?.map(obj => obj._id?.toString()).includes(selectedDepartamento) &&
      ct.subDepartamentos?.map(obj => obj._id?.toString()).includes(selectedSubDepartamento)
    );

    if (!registroTallas) continue;


    for (let tallaAsignada of registroTallas.tallas) {
      coloresArticulo.forEach((color) => {
        const tallaId = tallaAsignada?._id?.toString() || tallaAsignada?.toString();
        const colorId = color?._id?.toString() || color?.toString();

        const i = nuevosTC.findIndex((item) => {
          const itemTallaId = item.tallas?._id?.toString() || item.tallas?.toString();
          const itemColorId = item.colores?._id?.toString() || item.colores?.toString();
          return itemTallaId === tallaId && itemColorId === colorId;
        });

        if (i !== -1) {
          // console.log(`Hola ✅ Coincidencia encontrada para color/talla. Sumando 1 en índice ${i}`);
          nuevosTC[i].cantidad += 1;
        } else {
          // console.log("Hola ❌ No se encontró combinación exacta en nuevosTC");
        }
      });
    }
  }

  // Multiplica cada cantidad final por cantidadGlobal
  nuevosTC.forEach((item) => {
    item.cantidad = item.cantidad * cantidadGlobal;
  });

  const updatedInputFields = inputFields.map((i) => {
    if (i.id === id) {
      const totalArt = nuevosTC.reduce((acc, item) => acc + (parseInt(item.cantidad) || 0), 0);
      const precio = parseFloat(selectedArticulo.venta) || 0;
      const descuento = parseFloat(input?.descuento || 0);
      const total = parseFloat((totalArt * precio * (1 - descuento / 100)).toFixed(2));

      return {
        ...i,
        idArticulos: selectedArticulo._id,
        articulos: selectedArticulo,
        codigoCliente: selectedArticulo.codigoCliente,
        codigo: `${selectedArticulo.codigo} ${selectedArticulo.descripcion}`,
        precio: selectedArticulo.venta,
        colores: coloresArticulo,
        tallas: tallasArticulo,
        tc: nuevosTC,
        arrayColoresArticulo: coloresArticulo,
        totalArt,
        total,
      };
    }
    return i;
  });

  setInputFields(updatedInputFields);
  ActualizaTotales(updatedInputFields);
}







const ActualizaTotales = (fields = inputFields) => {
  let totalPiezas = 0;
  let totalDinero = 0;

  fields.forEach((field) => {
    totalPiezas += parseFloat(field.totalArt) || 0;
    totalDinero += parseFloat(field.total) || 0;
  });

  setTotalPiezas(totalPiezas);
  setTotalGeneral(parseFloat(totalDinero.toFixed(2)));
};



  function explosiones() {
    
    setInputFieldsTela([
      {
        id: uuidv4(),
        idTela: "",
        idColor: "",
        cantidad: 0,
        observaciones: "NA",
      },
    ]);
    toggleExplosiones();
  }


  const handleRemoveFieldsTelas = (id) => {
    const values = [...inputFieldsTela];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsTela(values);
  };


const handleAddFieldsTelas = () => {
  setInputFieldsTela([
    ...inputFieldsTela,
    {
      id: uuidv4(),
      idTela: "",
      idColor: "",
      cantidad: 0,
      observaciones: "NA",
    },
  ]);
};
const handleChangeInputTela = (id, event) => {
  const newInputFieldsTela = inputFieldsTela.map((i) => {
    if (id === i.id) {
      i[event.target.name] = event.target.value;
    }
    return i;
  });
  setInputFieldsTela(newInputFieldsTela);
};

  const options = clientes.map((option) => {
    const junta = option.nombre_comercial;
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

const handleInputFieldChange = (id, fieldName, value) => {
  setInputFields((prevFields) => {
    const updatedFields = prevFields.map((field) => {
      if (field.id === id) {
        const updatedField = { ...field, [fieldName]: value };

        // Si cambia precio o descuento, recalcula total del artículo
        if (fieldName === "precio" || fieldName === "descuento") {
          const totalArt = parseFloat(updatedField.totalArt) || 0;
          const precio = parseFloat(updatedField.precio) || 0;
          const descuento = parseFloat(updatedField.descuento) || 0;

          updatedField.total = parseFloat(
            (totalArt * precio * (1 - descuento / 100)).toFixed(2)
          );
        }

        return updatedField;
      }
      return field;
    });

    // Llama a ActualizaTotales después de actualizar inputFields
    setTimeout(() => {
      ActualizaTotales(updatedFields);
    }, 0);

    return updatedFields;
  });
};

const handleChangeInputCantidad = (idField, idColor, idTalla, event) => {
  const nuevaCantidad = parseInt(event.target.value) || 0;

  setInputFields((prevFields) =>
    prevFields.map((field) => {
      if (field.id === idField) {
        const nuevaTC = field.tc.map((tcItem) => {
          const colorId = tcItem.colores?._id?.toString();
          const tallaId = tcItem.tallas?._id?.toString();
          if (colorId === idColor?.toString() && tallaId === idTalla?.toString()) {
            return { ...tcItem, cantidad: nuevaCantidad };
          }
          return tcItem;
        });

        const nuevoTotalArt = nuevaTC.reduce(
          (acc, item) => acc + (parseInt(item.cantidad) || 0),
          0
        );

        const precio = parseFloat(field.precio) || 0;
        const descuento = parseFloat(field.descuento) || 0;

        const nuevoTotal = parseFloat(
          (nuevoTotalArt * precio * (1 - descuento / 100)).toFixed(2)
        );

        return {
          ...field,
          tc: nuevaTC,
          totalArt: nuevoTotalArt,
          total: nuevoTotal,
        };
      }
      return field;
    })
  );

  ActualizaTotales();
};



function cargarArticulosDesdeCotizacion(articulosCot) {
  const nuevosInputFields = articulosCot.map((item) => {
    const articulo = articulos.find((a) => a._id === item.articulos?.[0]?._id);
    if (!articulo) return null;

    const id = uuidv4();
    const colores = item.colores || articulo.colores || [];
    const tallas = item.tallas || articulo.tallas || [];

    const combinacionesTC = [];
    colores.forEach((col) => {
      tallas.forEach((talla) => {
        combinacionesTC.push({
          colores: col._id,
          tallas: talla._id,
          tallaNombre: talla.name || talla.nombre,
          cantidad: 0,
        });
      });
    });

    return {
      id,
      articulos: articulo._id,
      codigo: articulo.codigo + " " + articulo.descripcion,
      precio: item.precio || articulo.venta || 0,
      total: 0,
      totalArt: 0,
      coloresArticulo: colores,
      tallasArticulo: tallas,
      arrayColoresArticulo: colores,
      tc: combinacionesTC,
      areasClientes: item.areasClientes?.[0]?._id || "", // ⚠️ importante
      sucursales: item.sucursales?.[0]?._id || "", // ⚠️ importante
      articulosNombre: articulo,
      tela: item.tela,
    };
  }).filter(Boolean); // Elimina nulos

  setInputFields(nuevosInputFields);
}


const options2 = articulos
  .filter((option) => typeof option.codigo === "string" && option.codigo.length > 0)
  .map((option) => {
    const firstLetter = option.codigo[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta: option.codigo + " " + option.descripcion, // junta bien formada
    };
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pedidos_create ? (
        <div className="card container col-12">
          <h3 align="center">Nuevo Pedido</h3>
          <Form onSubmit={savePedido} onKeyDown={evitaGuardarConEnter}>
            <Row>
              <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cliente</Label>
                <Autocomplete
                  size="small"
                  value={value}
                  onChange={(event, selectedCliente) => {
                    setValue(selectedCliente);
                  }}
                  options={options.sort(
                    (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                  )}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option.junta}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Selecciona"
                      variant="outlined"
                    />
                  )}
                  renderOption={(option) => (
                    <React.Fragment>{option.nombre_comercial}</React.Fragment>
                  )}
                />
              </Col>

              <Col md={2}>
                <Label>Vendedor</Label>
                <Input
                  type="select"
                  value={selectedColaborador}
                  required
                  onChange={(e) => {
                    setSelectedColaborador(e.target.value);
                  }}
                >
                  <option value="">Selecciona un Vendedor</option>
                  {colaboradores
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      return (
                        <option value={a._id}>
                          {a.nombre} {a.apellido}
                        </option>
                      );
                    })}
                </Input>
              </Col>
              {/* <Col md={2}>
                <Label>Cotizacion (Opcional)</Label>
                <Input
                  type="select"
                  disabled={!value?._id}
                  value={selectedCotizacion}
                  onChange={(e) => setSelectedCotizacion(e.target.value)}
                >
                  <option value="">Selecciona</option>
                  {cotizacionesCliente
                    .sort((a, b) => (a.idCotizacion > b.idCotizacion ? 1 : -1))
                    .map((a) => (
                      <option key={a._id} value={a._id}>
                        {a.idCotizacion}{" "}
                      </option>
                    ))}
                </Input>
              </Col> */}
              <Col md={2}>
                <Label>Fecha Cancelacion</Label>
                <Input
                  type="date"
                  placeholder="Fecha Cancelacion"
                  value={fecha_cancelacion}
                  required
                  onChange={(e) => {
                    setFechaCancelacion(e.target.value);
                    let inicio = new Date(e.target.value);
                    let bla = inicio.setDate(inicio.getDate() - 41);
                    setFechaConfirmacion(moment(bla).format("YYYY-MM-DD"));
                  }}
                />
              </Col>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Pedido Cliente
                </Label>
                <Input
                  type="text"
                  placeholder="Pedido Cliente"
                  value={pedidoCliente}
                  required
                  onChange={(e) => {
                    setPedidoCliente(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={10}>
                <h4 id="logoutBoton">
                  TOTALES {total_piezas} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)}
                </h4>
              </Col>
            </Row>
            <br />
            {/* Tabla Articulos */}

            <Row>
              <Col md={1}>
                <Label className="mr-sm-2">Cant. x Persona</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Sucursal</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Area</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Buscar</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Articulos</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Tela</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Precio</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Piezas</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div
                key={inputField.id}
                style={{
                  borderBottom: "1px solid #ccc",
                  paddingBottom: "1rem",
                  marginBottom: "1rem",
                }}
              >
                {/* Fila principal del artículo */}
                <Row className="align-items-center mb-2">
                    <Col md={1}>
                    <Input
                      name="cantidadGlobal"
                      type="number"
                      placeholder="cantidadGlobal"
                      min={1}
                      disabled={
                        inputField.articulos !== undefined &&
                        inputField.articulos !== ""
                      }
                      value={inputField.cantidadGlobal ?? 1}
                      onChange={(e) =>
                        handleInputFieldChange(
                          inputField.id,
                          "cantidadGlobal",
                          e.target.value
                        )
                      }
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      type="select"
                      value={inputField.sucursales}
                      disabled={
                        inputField.articulos !== undefined &&
                        inputField.articulos !== ""
                      }
                      required
                      onChange={(e) =>
                        handleInputFieldChange(
                          inputField.id,
                          "sucursales",
                          e.target.value
                        )
                      }
                    >
                      <option value="">Selecciona</option>
                      {sucursalesClientes.map((suc) => (
                        <option key={suc._id} value={suc._id}>
                          {suc.alias}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      type="select"
                      value={inputField.areasClientes}
                      disabled={
                        inputField.articulos !== undefined &&
                        inputField.articulos !== ""
                      }
                      required
                      onChange={(e) =>
                        handleInputFieldChange(
                          inputField.id,
                          "areasClientes",
                          e.target.value
                        )
                      }
                    >
                      <option value="">Selecciona</option>
                      {areasClientesOptions.map((area) => (
                        <option key={area._id} value={area._id}>
                          {area.nombre || area.name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col md={2}>
             <Autocomplete
  size="small"
  value={inputField.articulosNombre}
  onChange={(event, selectedArticulo) =>
    BuscaArticulo(inputField.id, selectedArticulo)
  }
  options={options2.sort(
    (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
  )}
  groupBy={(option) => option.firstLetter}
  getOptionLabel={(option) => option.junta}
  disabled={
    !inputField.areasClientes || !inputField.sucursales
  }
  renderInput={(params) => (
    <TextField
      {...params}
      label="Selecciona"
      variant="outlined"
      helperText={
        !inputField.areasClientes || !inputField.sucursales
          ? "Selecciona área y sucursal primero"
          : ""
      }
    />
  )}
  renderOption={(option) => (
    <React.Fragment>{option.codigo}</React.Fragment>
  )}
/>


                  </Col>

                  <Col md={2}>
                    <Input
                      name="codigo"
                      type="text"
                      placeholder="Código"
                      value={inputField.codigo || ""}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      name="tela"
                      type="text"
                      placeholder="Tela"
                      value={inputField.tela || ""}
                      onChange={(e) =>
                        handleInputFieldChange(
                          inputField.id,
                          "tela",
                          e.target.value
                        )
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      name="precio"
                      type="number"
                      placeholder="Precio"
                      value={inputField.precio}
                      onChange={(e) =>
                        handleInputFieldChange(
                          inputField.id,
                          "precio",
                          parseFloat(e.target.value) || 0
                        )
                      }
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      name="totalArt"
                      type="number"
                      placeholder="Piezas"
                      value={inputField.totalArt}
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      name="total"
                      type="number"
                      placeholder="Total"
                      value={inputField.total}
                      disabled
                    />
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabIndex="-1"
                    >
                      <i className="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      color="info"
                      onClick={handleAddFields}
                      tabIndex="-1"
                    >
                      <i className="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>

                {/* Tallas por color debajo */}
{/* {console.log("Hola 👉 TC:", inputField.tc)}
{console.log("Hola 🎨 ColoresArticulo:", inputField.arrayColoresArticulo)} */}

{inputField.arrayColoresArticulo.map((col) => (
  <Row key={col._id} className="align-items-center mb-1 ps-3">
    <Col md={1}>
      <strong>{col.name}</strong>
    </Col>
    <Col md={11}>
      <Row>
        {inputField.tc
          ?.filter((a) => {
            const colorIdA = a.colores?._id?.toString();
            const colorIdCol = col?._id?.toString();
            return colorIdA === colorIdCol;
          })
          ?.sort((a, b) => {
            const limpiarNombre = (nombre) => nombre.split(" ")[0];
            const indexA = ordenTallas.indexOf(limpiarNombre(a.tallaNombre));
            const indexB = ordenTallas.indexOf(limpiarNombre(b.tallaNombre));
            return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
          })
          ?.map((a) => (
            <Col key={a.tallas._id} md="auto" className="text-center">
              <Label>{a.tallaNombre}</Label>
              <Input
                bsSize="sm"
                name="cantidad"
                type="number"
                value={a.cantidad}
                onChange={(event) =>
                  handleChangeInputCantidad(
                    inputField.id,
                    a.colores._id,
                    a.tallas._id,
                    event
                  )
                }
                style={{ width: "60px" }}
              />
            </Col>
          ))}
      </Row>
    </Col>
  </Row>
))}



              </div>
            ))}

            <Row>
              <Col md={10}>
                <h4 id="logoutBoton">
                  TOTALES {total_piezas} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)}
                </h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoPedidos"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
          <Modal size="xl" isOpen={modalExplosiones} toggle={toggleExplosiones}>
            <ModalHeader toggle={toggleExplosiones}>
              <h4>Explosion Modelo</h4>
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col md={3}>
                  <Label>Tela</Label>
                </Col>
                <Col md={2}>
                  <Label>Color</Label>
                </Col>
                <Col md={2}>
                  <Label>Metros Totales</Label>
                </Col>
                <Col md={3}>
                  <Label>Observaciones</Label>
                </Col>
              </Row>

              {inputFieldsTela.map((a) => (
                <div key={a.id}>
                  <Row>
                    <Col md={3}>
                      <Input
                        bsSize="sm"
                        name="idTela"
                        type="select"
                        value={a.idTela}
                        required
                        onChange={(event) => {
                          handleChangeInputTela(a.id, event);
                        }}
                      >
                        <option value="">Selecciona</option>
                        {/* (2026-10) las telas dadas de baja no se ofrecen */}
                        {telas
                          .filter((t) => t.is_active !== "No" || t._id === a.idTela)
                          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                          .map((a) => {
                            return (
                              <option value={a._id}>
                                {a.nombre} / {a.tiposTelas[0].name}
                              </option>
                            );
                          })}
                      </Input>
                    </Col>
                    <Col md={2}>
                      <Input
                        bsSize="sm"
                        name="idColor"
                        type="select"
                        value={a.idColor}
                        required
                        onChange={(event) => {
                          handleChangeInputTela(a.id, event);
                        }}
                      >
                        <option value="">Selecciona</option>
                        {colores
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                            return <option value={a._id}>{a.name}</option>;
                          })}
                      </Input>
                    </Col>
                    <Col md={2}>
                      <Input
                        bsSize="sm"
                        name="cantidad"
                        type="number"
                        value={a.cantidad}
                        onChange={(event) => {
                          handleChangeInputTela(a.id, event);
                        }}
                      ></Input>
                    </Col>
                    <Col md={3}>
                      <Input
                        bsSize="sm"
                        name="observaciones"
                        type="text"
                        value={a.observaciones}
                        onChange={(event) => {
                          handleChangeInputTela(a.id, event);
                        }}
                      ></Input>
                    </Col>
                    <Col>
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        disabled={inputFieldsTela.length === 1}
                        onClick={() => handleRemoveFieldsTelas(a.id)}
                        tabindex="-1"
                      >
                        <i class="fas fa-minus"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={handleAddFieldsTelas}
                        tabindex="-1"
                      >
                        <i class="fas fa-plus"></i>
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))}
              <br />
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default PedidosCreateTallas;
